import { Reducer } from 'redux';
import { CurrentModuleState, CurrentModuleTypes } from './types';

const INITIAL_STATE: CurrentModuleState = {
  currentModuleData: '9',
};

const reducer: Reducer<CurrentModuleState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES SET_CURRENT_MODULE
    case CurrentModuleTypes.SET_CURRENT_MODULE:
      return {
        ...state,
        loading: false,
        error: false,
        currentModuleData: action.payload.module,
      };

    default:
      return state;
  }
};

export default reducer;
